import React, { FC } from 'react';

import { LoginSettings } from 'src/components/property-settings/sections/login-settings/LoginSettings';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';

import { useSetProperty } from './utils/useSetProperty';

export const LoginSectionModule: FC = () => {
	const {
		state: { draft, original, errors }
	} = usePropertySettings();
	const setProperty = useSetProperty();

	return (
		<LoginSettings
			originalProperty={original}
			property={draft}
			setProperty={setProperty}
			propertyError={errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.LOGIN)}
		/>
	);
};
